var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublictransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-158-202H992v754H-158z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.991 70.587c-.001-.027.004-.054.002-.08l-1.98-23.767c.001-.023.007-.045.007-.068 0-.172-.021-.339-.062-.498-.532-4.249-4.279-11.6-14.965-12.42.001-.028.008-.054.008-.082v-5h5a2 2 0 0 0 0-4h-31a2 2 0 0 0 0 4h5v5c0 .031.008.06.009.09-10.138.883-14.229 8.44-14.977 12.552-.005.028-.002.055-.006.083-.005.037-.016.071-.02.11l-2 24c-.002.026.003.053.002.08-.002.028-.009.055-.009.085v18a2 2 0 0 0 1.367 1.897c.215.071 2.525.83 6.199 1.676l-6.398 14.625a2 2 0 0 0 3.664 1.604l2.101-4.802h41.134l2.101 4.802a2 2 0 1 0 3.664-1.604l-6.36-14.536c3.718-.888 6.006-1.708 6.211-1.782a2.001 2.001 0 0 0 1.316-1.88v-18c.001-.03-.006-.057-.008-.085zM41.84 48.672h43.32l1.666 20H40.174l1.666-20zm28.16-20v5H57v-5h13zm-15 9h17c8.299 0 11.329 4.276 12.418 7h-41.62c1.326-2.78 4.593-7 12.202-7zm27.317 62H44.683l2.884-6.593c4.561.852 10.29 1.593 16.433 1.593 5.879 0 11.212-.679 15.48-1.485l2.837 6.485zM87 87.222c-3.272 1.011-12.282 3.45-23 3.45-10.811 0-20.514-2.48-24-3.484V72.672h47v14.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 87.672h5c2.757 0 5-2.243 5-5v-2c0-2.757-2.243-5-5-5h-5c-2.757 0-5 2.243-5 5v2c0 2.756 2.243 5 5 5zm-1-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2zM50 87.672h5c2.757 0 5-2.243 5-5v-2c0-2.757-2.243-5-5-5h-5c-2.757 0-5 2.243-5 5v2c0 2.756 2.243 5 5 5zm-1-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublictransport);
export default __webpack_public_path__ + "static/media/publictransport.aeb45e9c98435601703e603b4c38ad88.svg";
export { ForwardRef as ReactComponent };